
import PickerDate from '@/components/picker-date.vue';
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import Message from '@/components/message.vue';
import {
	activityMarkdownlist,
	activityMarkdowndelete,
} from "@/api/material"
import {
	nextDay
} from "@/utils"
@Component({
	name: '',
	components: {
		PageFooter,
		PickerDate,
		'slz-message': Message,
	}
})

export default class ProductList extends Vue {
	private time: any = []
	private keywords = ''
	private state = null
	private statelist = [
		{ value: null, label: '全部' },
		{ value: 0, label: '未开始' },
		{ value: 1, label: '进行中' },
		{ value: 2, label: '已结束' },
	]
	private pageSize = 20
	private pageNo = 1
	private total = 0
	private tablelist: any = []
	private tableloading = false

	private rowmsg: any = {}
	private delShow = false


	private mounted() {
		this.gettablelist()
	}

	private async confirmdel() {
		try {
			this.tableloading = true
			let res: any = await activityMarkdowndelete({
				Id: this.rowmsg.Id
			})
			if (res.IsSuccess) {
				this.$message.success('操作成功')
				this.delShow = false
				this.gettablelist()
			}
		} finally {
			this.tableloading = false
		}
	}
	private detele(row) {
		this.rowmsg = row
		this.delShow = true
	}
	private todetails(row) {
		this.$router.push({
			path: 'fullsubtraction_details',
			query: {
				Id: row.Id
			}
		})
	}
	private handleToActivityDatas(record){
		this.$router.push({
			path: 'fullsubtraction_datas',
			query: {
				id: record.Id,
				name: record.ActivityName
			}
		})
	}
	private doSearch() {
		this.pageNo = 1
		this.gettablelist()
	}
	private clearSearch() {
		this.time = []
		this.keywords = ''
		this.state = null
		this.doSearch()
	}
	private changePage(e) {
		this.pageNo = e
		this.gettablelist()
	}
	async gettablelist() {
		try {
			// console.log(this.time)
			this.tableloading = true
			let data: any = {
				StartTime: this.time && this.time[0],
				EndTime: this.time && nextDay(this.time[1], 1),
				Keywords: this.keywords,
				State: this.state,
				Skip: (this.pageNo - 1) * this.pageSize,
				Take: this.pageSize
			}
			let res: any = await activityMarkdownlist(data)
			if (res.IsSuccess) {
				this.tablelist = res.Result.Results
				this.total = res.Result.Total
			}
		} finally {
			this.tableloading = false
		}
	}
}
